export default function Step5(props: any) {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle cx="34.0898" cy="27.904" r="16.904" stroke="black" strokeWidth="3" />
            <path d="M23.9474 41.9473L14 52.9999" stroke="black" strokeWidth="3" strokeLinecap="round" />
            <path d="M26.288 29.5585L31.3383 34.6088L42.449 24.0032" stroke="#010101" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
